export enum PTCTrackerSteps {
  INITIATED = "initiated",
  VALUED = "valued",
  SENT = "sent for payment",
  PAID = "paid",
}
